/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.loyalty.brand.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../../validate/validate_pb.js')

var witbooking_backoffice_loyalty_tier_v1_loyalty_tier_api_pb = require('../../../../../witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.loyalty = {};
proto.witbooking.backoffice.loyalty.brand = {};
proto.witbooking.backoffice.loyalty.brand.v1 = require('./loyalty_brand_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_CreateLoyaltyBrand = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/CreateLoyaltyBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse>}
 */
const methodInfo_LoyaltyBrandAPI_CreateLoyaltyBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.createLoyaltyBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/CreateLoyaltyBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_CreateLoyaltyBrand,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.CreateLoyaltyBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.createLoyaltyBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/CreateLoyaltyBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_CreateLoyaltyBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_UpdateLoyaltyBrand = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/UpdateLoyaltyBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse>}
 */
const methodInfo_LoyaltyBrandAPI_UpdateLoyaltyBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.updateLoyaltyBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/UpdateLoyaltyBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_UpdateLoyaltyBrand,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.UpdateLoyaltyBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.updateLoyaltyBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/UpdateLoyaltyBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_UpdateLoyaltyBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_DeleteLoyaltyBrand = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/DeleteLoyaltyBrand',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse>}
 */
const methodInfo_LoyaltyBrandAPI_DeleteLoyaltyBrand = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.deleteLoyaltyBrand =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/DeleteLoyaltyBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_DeleteLoyaltyBrand,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.DeleteLoyaltyBrandResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.deleteLoyaltyBrand =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/DeleteLoyaltyBrand',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_DeleteLoyaltyBrand);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandById = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandById',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse>}
 */
const methodInfo_LoyaltyBrandAPI_GetLoyaltyBrandById = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.getLoyaltyBrandById =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandById',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandById,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByIdResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.getLoyaltyBrandById =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandById',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandById);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandByTicker = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandByTicker',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse>}
 */
const methodInfo_LoyaltyBrandAPI_GetLoyaltyBrandByTicker = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.getLoyaltyBrandByTicker =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandByTicker',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandByTicker,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandByTickerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.getLoyaltyBrandByTicker =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandByTicker',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandByTicker);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandsUsedByProperty = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandsUsedByProperty',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse>}
 */
const methodInfo_LoyaltyBrandAPI_GetLoyaltyBrandsUsedByProperty = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.getLoyaltyBrandsUsedByProperty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandsUsedByProperty',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandsUsedByProperty,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsUsedByPropertyResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.getLoyaltyBrandsUsedByProperty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandsUsedByProperty',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandsUsedByProperty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandsManagedByProperty = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandsManagedByProperty',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse>}
 */
const methodInfo_LoyaltyBrandAPI_GetLoyaltyBrandsManagedByProperty = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.getLoyaltyBrandsManagedByProperty =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandsManagedByProperty',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandsManagedByProperty,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.GetLoyaltyBrandsManagedByPropertyResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.getLoyaltyBrandsManagedByProperty =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/GetLoyaltyBrandsManagedByProperty',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_GetLoyaltyBrandsManagedByProperty);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_ConfigureBookAndJoin = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/ConfigureBookAndJoin',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse>}
 */
const methodInfo_LoyaltyBrandAPI_ConfigureBookAndJoin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.configureBookAndJoin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/ConfigureBookAndJoin',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_ConfigureBookAndJoin,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureBookAndJoinResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.configureBookAndJoin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/ConfigureBookAndJoin',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_ConfigureBookAndJoin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse>}
 */
const methodDescriptor_LoyaltyBrandAPI_ConfigureRegistrationText = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/ConfigureRegistrationText',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest,
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest,
 *   !proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse>}
 */
const methodInfo_LoyaltyBrandAPI_ConfigureRegistrationText = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse,
  /**
   * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIClient.prototype.configureRegistrationText =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/ConfigureRegistrationText',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_ConfigureRegistrationText,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.loyalty.brand.v1.ConfigureRegistrationTextResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPIPromiseClient.prototype.configureRegistrationText =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.loyalty.brand.v1.LoyaltyBrandAPI/ConfigureRegistrationText',
      request,
      metadata || {},
      methodDescriptor_LoyaltyBrandAPI_ConfigureRegistrationText);
};


module.exports = proto.witbooking.backoffice.loyalty.brand.v1;

